import React from 'react';

import { InterestsForm } from '@/core/components/InterestsForm/InterestsForm';
import Modal from '@/core/components/Modal';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

export const InterestsModal: React.FC<{ isOpen: boolean; onClose: () => void }> = ({ isOpen, onClose }) => {
  const { t } = useTranslationContext(['common']);

  const onSubmit = async () => {
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} type="tunnel">
      <InterestsForm onCancel={onClose} onSubmit={onSubmit} content={t('control.interests.content', { ns: 'common' })} cancelButtonText={t('control.interests.cancel.modal', { ns: 'common' })} />
    </Modal>
  );
};
